export default __webpack_public_path__ + "slices/main/assets/public/media/product/platform/platform-feature-team@2x.415c2c73cae618c528a2b91f06cdce65.png";